import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LocaleProvider } from './i18n/LocaleContext';
import { LocaleSparkOverlay } from './components/LocaleSparkOverlay';
import { NotFound } from './NotFound';
import { Home } from './Home';
import { Everything } from './Everything';
import { Footer } from './Footer';

function App() {
  return (
    <LocaleProvider>
      <LocaleSparkOverlay />
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<NotFound/>} />
          <Route path="/" element={<Home/>} />
          <Route path="/index" element={<Home/>} />
          <Route path="/showcase" element={<Home/> } />
          <Route path="/everything" element={<Everything/>} />
        </Routes>
        <Footer/>
      </BrowserRouter>
    </LocaleProvider>
  );
}

export default App;
